export function processHtmlLinks(html: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const links = doc.querySelectorAll('a[href]');
  links.forEach(link => {
    const href = link.getAttribute('href');
    if (href && !href.startsWith('#') && !href.startsWith('javascript:')) {
      const urlText = document.createTextNode(`: ${href}`);
      link.parentNode?.insertBefore(urlText, link.nextSibling);
    }
  });

  return doc.documentElement.outerHTML;
}
